import type { PhotoResponse } from '../api/types';
import { useMediaUrl } from '../auth/ApiProvider';
import { useI18n } from '../i18n/I18nProvider';
import { noSave } from './noSave';
import { ProtectedVideo } from './ProtectedVideo';

type GalleryItem = Pick<PhotoResponse, 'kind' | 'url' | 'thumbnailUrl' | 'contentType' | 'caption'>;

/**
 * One gallery item: a photograph, or a video with the browser's own player.
 *
 * The link is signed and expires within fifteen minutes, so it is used and not kept (FR-PHO-04). Nothing
 * offers to save it (Q7).
 */
export function GalleryMedia({ item }: { item: GalleryItem }) {
  const { t } = useI18n();
  const media = useMediaUrl();

  if (item.kind !== 'Video') {
    return <img {...noSave} src={media(item.thumbnailUrl ?? item.url)} alt={item.caption ?? ''} loading="lazy" />;
  }

  // Only the length and the first frame until the parent presses play (`preload="metadata"`): a gallery of
  // videos must not download all of them on a phone connection.
  return (
    <ProtectedVideo src={media(item.url) ?? item.url} type={item.contentType} label={item.caption ?? t('photos.video')} />
  );
}
